import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme=>({
	contenedor: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'center',
		margin: '0px 38px 10px 38px',
	},
	contenedorCard: {
		margin: '0px 10px',
		textAlign: 'center',
	},
	cardContent: {
		padding: '5px',
		// height: '90px',
		width: '150px',
	},
	iconGeneradas: {
		color: 'green',
	},
	iconPendientes: {
		color: 'red',
	},
	typographyTitulo: {
		fontSize: '15px',
		fontWeight: 'bold',
	},
	typographyTotales: {
		fontSize: '30px',
		fontWeight: 'bold',
	},
	avatar:{
		backgroundColor: 'white',
		color: 'black',
		height: '100%',
	},	
}))